import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "year-month-picker__content" }
const _hoisted_2 = { class: "year-picker-container" }
const _hoisted_3 = { class: "year-picker-container__title" }
const _hoisted_4 = { class: "month-picker-container" }
const _hoisted_5 = { class: "month-picker-container__title" }

import SimpleSelectField from '@/components/input/SimpleSelectField.vue';
import { i18n } from '@/i18n';
import { computed } from 'vue';
import { useYearMonthPickerStore } from '../store/useYearMonthPickerStore';

// store

export default /*@__PURE__*/_defineComponent({
  __name: 'YearMonthPicker',
  props: {
    inputDate: { default: () => new Date() }
  },
  emits: ["changeValue"],
  setup(__props: any, { emit: __emit }) {

const yearMonthPickerStore = useYearMonthPickerStore();

// props
const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;

//computed
const date = computed({
  /**
   * getメソッド
   */
  get: () => props.inputDate,
  /**
   * setメソッド
   * @param value - props.inputDate
   */
  set: (value) => {
    // 値に変更があると呼ばれるsetter
    if (!value) {
      return;
    }
    emits('changeValue', value);
  },
});

/**
 * 選択された日付情報に描画の更新を行う
 * @param receiveValue - 子から渡ってきた値
 * @param receiveDateType - 年月どちらが更新されたか(汎用性特に無いので、そのままunion入れてます)
 */
const updateValue = (receiveValue: string, receiveDateType: 'year' | 'month') => {
  switch (receiveDateType) {
    case 'year':
      date.value.setDate(1);
      date.value.setFullYear(Number(receiveValue));
      break;
    case 'month':
      date.value.setDate(1);
      date.value.setMonth(Number(receiveValue));
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SimpleSelectField, {
        class: "year-picker-container__content",
        options: _unref(yearMonthPickerStore).initSelectedYearValue(props.inputDate),
        "selected-value": `${date.value.getFullYear()}`,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateValue($event, 'year')))
      }, null, 8, ["options", "selected-value"]),
      _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(t)('年')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(SimpleSelectField, {
        class: "month-picker-container__content",
        options: _unref(yearMonthPickerStore).initSelectedMonthValue(),
        "selected-value": `${date.value.getMonth()}`,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (updateValue($event, 'month')))
      }, null, 8, ["options", "selected-value"]),
      _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('月')), 1)
    ])
  ]))
}
}

})